// extracted by mini-css-extract-plugin
export var label = "_cu-5";
export var slideContainer = "_cu-0";
export var slider = "_cu-1";
export var sliderLg = "_cu-4";
export var sliderMd = "_cu-3";
export var sliderSm = "_cu-2";